import * as types from "./consts";

export const postSignUpRequest = (payload: object) => ({
  type: types.POST_CREATE_TENANT_REQUEST,
  payload,
});
